import * as React from 'react'
export const SvgBlackTwitter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={40} height={40} {...props}>
    <defs>
      <filter color-interpolation-filters="auto" id="filter-1">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 0.200000 0 0 0 0 0.200000 0 0 0 0 0.200000 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g
      id="Icon-Twitter"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon-Twitter" filter="url(#filter-1)">
        <g
          id="Twitter"
          transform="translate(0.000000, 2.769231)"
          fill="#333333"
        >
          <path d="M20.7310345,3.04973475 C21.7268966,2.44814324 22.4910345,1.4928382 22.8510345,0.357891247 C21.9186207,0.914920424 20.8882759,1.31876658 19.7875862,1.53600796 C18.9103448,0.591843501 17.6565517,0 16.2689655,0 C13.6082759,0 11.4496552,2.18076923 11.4496552,4.86843501 C11.4496552,5.25 11.4910345,5.6204244 11.5737931,5.97692308 C7.56689655,5.77221485 4.01517241,3.83793103 1.63586207,0.888461538 C1.22068966,1.6112069 0.983448276,2.44814324 0.983448276,3.33938992 C0.983448276,5.02579576 1.83448276,6.51724138 3.12827586,7.39038462 C2.33931034,7.36671088 1.59448276,7.14668435 0.943448276,6.78322281 L0.943448276,6.84310345 C0.943448276,9.20212202 2.60551724,11.1698276 4.81241379,11.6168435 C4.40827586,11.7310345 3.98206897,11.78813 3.54206897,11.78813 C3.23172414,11.78813 2.92827586,11.7588859 2.63448276,11.7017905 C3.24827586,13.6346817 5.02758621,15.0425729 7.13793103,15.081565 C5.48827586,16.3864058 3.40827586,17.1648541 1.15034483,17.1648541 C0.76137931,17.1648541 0.376551724,17.1425729 0,17.0980106 C2.1337931,18.4780504 4.66896552,19.2843501 7.39034483,19.2843501 C16.2593103,19.2843501 21.1075862,11.8675066 21.1075862,5.43242706 C21.1075862,5.22214854 21.1034483,5.01047745 21.0951724,4.80298408 C22.0372414,4.11644562 22.8551724,3.26001326 23.4993103,2.28242706 C22.6358621,2.67095491 21.7062069,2.93136605 20.7310345,3.04973475 Z"></path>
        </g>
      </g>
    </g>
  </svg>
)
export default SvgBlackTwitter
